import React from "react";
import { DatePicker } from "antd";
import PropTypes from "prop-types";
import "./styles.scss";

const { RangePicker } = DatePicker;

const CalendarComponent = ({
  type = "single",
  value,
  onChange,
  placeholder,
  disabled = false,
  format = "YYYY-MM-DD",
  style,
  className,
  allowClear = true,
  showTime = false,
  disabledDate,
  ...props
}) => {
  const handleChange = (date, dateString) => {
    if (onChange) {
      onChange(date, dateString);
    }
  };

  const commonProps = {
    value,
    onChange: handleChange,
    disabled,
    format,
    style,
    className,
    allowClear,
    showTime,
    disabledDate,
    ...props,
  };

  return type === "range" ? (
    <RangePicker
      {...commonProps}
      placeholder={placeholder || ["Start Date", "End Date"]}
    />
  ) : (
    <DatePicker
      {...commonProps}
      placeholder={placeholder || "Select Date"}
    />
  );
};

CalendarComponent.propTypes = {
  type: PropTypes.oneOf(["single", "range"]),
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  disabled: PropTypes.bool,
  format: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  allowClear: PropTypes.bool,
  showTime: PropTypes.bool,
  disabledDate: PropTypes.func,
};

export default CalendarComponent; 
